'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import { getHasGlobalContentEditorAccess } from 'DesignData/selectors/auth';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as SfdcIntegrationStatusActions from 'DesignData/actions/SalesforceIntegrationStatus';
import { getUserHasReadAccessOnly } from 'DesignData/selectors/auth';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import StyleGroupEdit from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/StyleGroupEdit';
import { STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';

function makeMapStateToProps() {
  const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
  const getCustomWidgetBufferFields = customWidgetBuffersSelectors.makeGetCustomWidgetBufferFields();
  const getIsEmailOrAnyType = customWidgetBuffersSelectors.makeGetIsEmailOrAnyType();
  const getIsReadOnly = customWidgetBuffersSelectors.makeGetIsReadOnly();
  return (state, props) => {
    const customWidgetBuffer = getCustomWidgetBuffer(state, props);
    const {
      isActive
    } = customWidgetEditorOptionsSelectors.getFieldGrouping(state, props);
    const selectedField = customWidgetEditorOptionsSelectors.getSelectedField(state, props);
    const isEditingGlobalContent = customWidgetEditorOptionsSelectors.getIsEditingGlobalContent(state, props);
    return Object.assign({
      customWidgetId: props.customWidgetId,
      isReadOnly: getUserHasReadAccessOnly(state) || getIsReadOnly(state, props) || isEditingGlobalContent,
      fieldErrors: customWidgetEditorOptionsSelectors.getFieldErrors(state, props),
      fieldBreadcrumbs: customWidgetEditorOptionsSelectors.getSelectedFieldBreadcrumbs(state, props),
      fields: getCustomWidgetBufferFields(state, props),
      isFieldGroupingActive: !!isActive,
      isFullScreenEditorOpen: customWidgetEditorOptionsSelectors.getIsFullScreenEditorOpen(state, props),
      customWidgetIcon: customWidgetBuffer ? customWidgetBuffer.icon : null,
      isGlobal: customWidgetBuffer ? customWidgetBuffer.global : false,
      isV1: customWidgetBuffer ? customWidgetBuffer.schemaVersion === 1 : false,
      isStyleTab: selectedField.field && selectedField.field.tab === STYLE,
      accordionStates: customWidgetEditorOptionsSelectors.getAccordionStates(state, props),
      isEmailOrAnyType: getIsEmailOrAnyType(state, props),
      customWidgetPath: customWidgetBuffer ? customWidgetBuffer.path : '',
      hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state, props)
    }, selectedField);
  };
}

const mapDispatchToProps = {
  cloneField: CustomWidgetBufferActions.cloneField,
  deleteField: CustomWidgetBufferActions.deleteField,
  editField: CustomWidgetBufferActions.editField,
  setSelectedField: CustomWidgetEditorOptionsActions.setSelectedField,
  saveAccordionState: CustomWidgetEditorOptionsActions.saveAccordionState,
  fetchSfdcIntegrationStatus: SfdcIntegrationStatusActions.fetch,
  setFullScreenEditorOpen: CustomWidgetEditorOptionsActions.setFullScreenEditorOpen
};

class StyleGroupEditContainer extends Component {
  constructor(...args) {
    super(...args);

    this.saveAccordionState = (key, isOpen = false) => {
      this.props.saveAccordionState(this.props.customWidgetId, key, isOpen, this.props.field.id);
    };
  }

  componentDidMount() {
    this.props.fetchSfdcIntegrationStatus();
  }

  render() {
    const {
      customWidgetIcon,
      customWidgetId,
      customWidgetPath,
      editField,
      field,
      fieldErrors,
      deleteField,
      isStyleTab,
      isReadOnly
    } = this.props;
    return /*#__PURE__*/_jsx(StyleGroupEdit, {
      customWidgetIcon: customWidgetIcon,
      customWidgetId: customWidgetId,
      customWidgetPath: customWidgetPath,
      deleteField: deleteField,
      editField: editField,
      field: field,
      isStyleTab: isStyleTab,
      fieldErrors: fieldErrors,
      readOnly: isReadOnly
    });
  }

}

StyleGroupEditContainer.propTypes = {
  customWidgetIcon: PropTypes.string,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  customWidgetPath: PropTypes.string.isRequired,
  deleteField: PropTypes.func.isRequired,
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField),
  fieldErrors: PropTypes.object.isRequired,
  isStyleTab: PropTypes.bool,
  isReadOnly: PropTypes.bool.isRequired,
  saveAccordionState: PropTypes.func.isRequired,
  fetchSfdcIntegrationStatus: PropTypes.func.isRequired
};
StyleGroupEditContainer.defaultProps = {
  customWidgetIcon: null,
  field: null,
  accordionStates: {}
};
export default connect(makeMapStateToProps, mapDispatchToProps)(StyleGroupEditContainer);